import { Spinner as SpinnerComponent } from '@wordpress/components';
import clsx from 'clsx';

interface Props {
	big?: boolean;
	className?: string;
}

export default function Spinner( { big = false, className = '' }: Props ) {
	return (
		<SpinnerComponent
			className={ clsx(
				'app-spinner',
				{
					'app-spinner--big !m-0 !w-[calc(4px_*_20)] !h-[calc(4px_*_20)]': big,
				},
				className
			) }
		/>
	);
}
